import React from "react";
import { Button as MButton } from "@mui/material";
import { styled } from "@mui/material";
import { Loader } from "../loaders";

const StyledButton = styled(MButton)`
  background-color: ${({ theme }) => theme.buttons.primary.background};
  border-radius: 100px;
  width: 100%;
  font-family: ${({ theme }) => theme.fonts.family.buttons};
  font-size: ${({ theme }) => theme.fonts.size.buttons}
  color: ${({ theme }) => theme.buttons.primary.color};

  &:focus {
    outline: 0;
  }
  &:hover {
    background-color: ${({ theme }) => theme.buttons.primary.backgroundHover};
  }
 
`;

const Button = ({
  children,
  loading,
  loaderType = "dots",
  loaderColor = "white",
  loaderSize = 24,
  disableElevation = true,
  ...otherProps
}) => (
  <StyledButton
    {...otherProps}
    disableElevation={disableElevation}
    variant="contained"
    fullWidth={true}
  >
    {!!loading ? (
      <Loader type={loaderType} stroke={loaderColor} size={loaderSize} />
    ) : (
      children
    )}
  </StyledButton>
);

export default Button;
